import BaseService from './base.service'
const API_URL = process.env.VUE_APP_API_URL

class ConfigService extends BaseService {
    getConfig(){
        return this.get(API_URL + `api/account/config`).then((response) => {
            return response.data
        })
    }
}
export default new ConfigService()